module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_1_F.c6149035.mp3";